import { combineReducers, Reducer } from 'redux';
import { reducer as language } from './modules/language/reducer';
import { FormStateMap, reducer as form } from 'redux-form';
import { LanguageAction } from './modules/language/actions';
import { LanguageState } from './modules/language/state';

export type RootAction = LanguageAction;

export interface RootState {
  form: FormStateMap;
  language: LanguageState;
}

export const rootReducer = combineReducers<RootState>({
  form: form as Reducer<FormStateMap>,
  language,
});



// WEBPACK FOOTER //
// ./src/rootState.tsx